<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择工单"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="repairOrders">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="工单编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" align="center" width="100px" label="编号"/>
      <el-table-column prop="equipmentName" align="center" label="设备名称"/>
      <el-table-column prop="faultTime" align="center" label="故障时间" width="140px"/>
      <el-table-column prop="urgency" align="center" width="80px" label="紧急程度">
        <template slot-scope="scope">
          <span>{{constant.urgencyType[scope.row.urgency]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairType" align="center" width="80px" label="修理方式">
        <template slot-scope="scope">
          <span>{{constant.faultDealMethod[scope.row.repairType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="result" align="center" width="80px" label="修理结果">
        <template slot-scope="scope">
          <span>{{constant.result[scope.row.result]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" width="100px" label="状态">
        <template slot-scope="scope">
          <span>{{constant.reportOrderStatus[scope.row.status]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";


  export default {
    name:"EMRepairOrderSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        filter: {
          no: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
